import {FeesArraySelector} from './../../../../../assets/descriptors/fees-form.descriptor';
import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {Subscription} from 'rxjs';

import {
    ApiError,
    ChargeSchedulesService,
    ChargeGroupModel,
    ChargeScheduleModel,
    TradingAccountDetailedReportModel, CashAccountDetailedReportModel
} from '@spa/api';

import {AlertsService} from '../../../../shared/services';
import {FormInterface} from '../../../../shared/interfaces';
import {FormComponent} from '../../../../shared/widgets/form';
import {DialogActionsEnum, DialogComponent, DialogConfigInterface} from '../../../../shared/components/dialog';

import {FeesForm} from '../../forms';
import {FeesFormErrorStatesEnum} from '../../enums/error-states';

import {AddFeeMessages} from '../../../../../assets/messages';
import { FeeEndDate } from 'appAssets/descriptors';
import { FormArray } from '@angular/forms';
import * as moment from 'moment';

@Component({
    selector: 'app-add-fee',
    templateUrl: './add-fee.component.html',
    styleUrls: ['./add-fee.component.scss']
})
export class AddFeeComponent extends DialogComponent<AddFeeComponent> implements OnInit, OnDestroy, FormInterface {
    private assignFeeSubscriptions: Subscription;
    private getFeeFailedNotifierSubscriptions: Subscription[];
    private endDateSubscription: Subscription;

    public feesForm: FeesForm;
    public title = 'Add Fee';
    public showEndDateWarning = false;

    constructor(
        private chargeSchedulesService: ChargeSchedulesService,
        private alertsService: AlertsService,
        @Inject(MAT_DIALOG_DATA) public data: {
            feeGroup: ChargeGroupModel,
            feeGroupText: string,
            account: TradingAccountDetailedReportModel | CashAccountDetailedReportModel,
            config: DialogConfigInterface,
            isValidityUpdate: boolean,
            modelToUpdate: ChargeScheduleModel
        },
        public dialogRef: MatDialogRef<AddFeeComponent>
    ) {
        super(dialogRef);

        this.config = data.config;
        this.getFeeFailedNotifierSubscriptions = [];
        if (data.isValidityUpdate) {
            this.title = 'Update Fee Validity';
        }
    }

    ngOnInit(): void {
        this.initForm();
    }

    ngOnDestroy(): void {
        this.feesForm.getFeesSubscriptions.map((subscription: Subscription) => {
            return (subscription && subscription.unsubscribe());
        });

        this.feesForm.feeTypeControlValueChangesSubscriptions.map((subscription: Subscription) => {
            return (subscription && subscription.unsubscribe());
        });

        this.getFeeFailedNotifierSubscriptions.map((subscription: Subscription) => {
            return (subscription && subscription.unsubscribe());
        });

        if (this.assignFeeSubscriptions) {
            this.assignFeeSubscriptions.unsubscribe();
        }

        if (this.feesForm.feeControlChangeSubscription){
            this.feesForm.feeControlChangeSubscription.unsubscribe();
        }
        if (this.endDateSubscription) {
            this.endDateSubscription.unsubscribe();
        }
    }

    initForm(): void {
        this.feesForm = new FeesForm(this.chargeSchedulesService);

        this.feesForm.initForm(
            this.data.feeGroup,
            this.data.feeGroupText,
            this.data.isValidityUpdate,
            this.data.modelToUpdate
        );

        this.getFeeFailedNotifierSubscriptions.push(this.feesForm.getFeesFailedNotifier.subscribe(() => {
            this.alertsService.addAlert(AddFeeMessages.GetFeesFailed.message);
        }));

        const formGroupsArray = this.feesForm.form.get(FeesArraySelector) as FormArray;
        const endDateControl = formGroupsArray.controls[0].get(FeeEndDate);
        this.endDateSubscription = endDateControl.valueChanges.subscribe((endDate: string) => {
            this.checkEndDate(endDate);
        });

    }

    getFormMessages(controlLabel?: string, controlLength?: number): { [p: string]: string } {

        return {
            ...FormComponent.getFormMessages(controlLabel, controlLength),
            [AddFeeMessages.WrongEndDateValue.key]: AddFeeMessages.WrongEndDateValue.message,
            [AddFeeMessages.EqualDataValue.key]: AddFeeMessages.EqualDataValue.message
        };
    }

    validateForm(): boolean {
        return this.feesForm.validateForm(this.getFormMessages);
    }

    onFormSubmit(action?: number): void {
        if (action !== DialogActionsEnum.Confirm) {
            this.dialogRef.close(!this.config.process.failed);
        } else {
            if (this.validateForm()) {
                this.startLoading(() => {
                    this.assignFeeSubscriptions = this.feesForm.createRequest(
                        this.data.account.accountReferenceId
                    ).subscribe(
                        this.dialogSubscribeHandler.bind(
                            this,
                            (data: ChargeScheduleModel[]) => {
                                this.data.account.accountChargeSchedules.push(...data);
                            },
                            (errors: ApiError[]) => {
                                this.config.process.failedMessage = errors.map((error: ApiError) => {
                                    if (error.status === FeesFormErrorStatesEnum.AssignFeeFailed) {
                                        return AddFeeMessages.FeeAssignmentFailed.message
                                            .replace('<<fee>>', `<b>${error.data}</b>`)
                                            .replace(
                                                '<<reference>>',
                                                `<b>${this.data.account.accountReferenceId}</b>`
                                            );
                                    }

                                    return AddFeeMessages.UnknownError.message;
                                }).join('</br>');
                            })
                    );
                });
            }
        }
    }
    checkEndDate(endDate: string) {
        const updateModel = this.data.modelToUpdate;
        const today = moment(new Date().setHours(0, 0, 0, 0)).unix();
        this.showEndDateWarning = moment(endDate).unix() < today &&
            moment(endDate).unix() !== moment(updateModel == null ? null : updateModel.endDate).unix();
    }
}
